import { useQuery } from "@tanstack/react-query";
import { getRevenueAnalysticEachStoreApi } from "../../services";
import { useAccountStore, useRevenueAnalysticEachStore } from "../../store";
import { useRevenueStoreAnalystic } from "../../store/revenue/revenue.store.analystic.store";

export const useGetRevenueAnalysticEachStoreApi = () => {
  const { year } = useRevenueAnalysticEachStore();
  const { info } = useAccountStore();
  const { monthSelect, yearSelect } = useRevenueStoreAnalystic();

  const { data, isLoading } = useQuery({
    queryKey: ["revenue-analystic-each-store", monthSelect, year, yearSelect],
    queryFn: () =>
      getRevenueAnalysticEachStoreApi(
        monthSelect,
        yearSelect ? yearSelect : year,
        // monthSelect > 2 ? monthSelect - 1 : 1,
        // info?.role === "ROLE_ADMIN" ? undefined : info?.id 
      ),
    enabled: !!year && !!info?.role,
  });

  return {
    revenueAnalysticEachStore: data,
    isLoading,
  };
};